const carousel = document.querySelector(".top-slider");
if (carousel) {
    const images = carousel.querySelectorAll("li");
    let currentImage = 0;
    let intervalTime = 3000;
    let transitionTime = 2000;
    transitionTime = transitionTime / 1000;
    images.forEach(image => {
        image.style.transition = `${transitionTime}s opacity`
    });

    function showNextImage() {
        images[currentImage].classList.remove("top-slider__item--active");
        currentImage = (currentImage + 1) % images.length;
        images[currentImage].classList.add("top-slider__item--active");
    }

    images[currentImage].classList.add("top-slider__item--active");

    setInterval(showNextImage, intervalTime);
}